import { useQuery } from "@tanstack/react-query";

import { consentDocumentsQueryOptionsFactory } from "../factories/consentDocumentsQueryOptionsFactory";

export const useListConsentDocuments = (organizationId: string) => {
  return useQuery(consentDocumentsQueryOptionsFactory.list({ organizationId }));
};
